import { render, staticRenderFns } from "./GlLoadHistory.vue?vue&type=template&id=0856ff36&scoped=true&"
import script from "./GlLoadHistory.vue?vue&type=script&lang=js&"
export * from "./GlLoadHistory.vue?vue&type=script&lang=js&"
import style0 from "./GlLoadHistory.vue?vue&type=style&index=0&id=0856ff36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0856ff36",
  null
  
)

export default component.exports